// extracted by mini-css-extract-plugin
module.exports = {"title":"QU5SfA2Hjwlr-oXqExlA6"};